import CarEntity from './CarEntity';
import ShopEntity from './ShopEntity';

export enum ServiceStatus {
    Parked = 'parked',
    WaitingForAcceptance = 'waitingForAcceptance',
    DeliveriedStarted = 'deliveredStarted',
    OnWayToDeliver = 'onWayToDeliver',
    WaitingForPickup = 'waitingForPickup',
    Delivered = 'delivered',
}

export interface ServiceEntity {
    id: string;
    qrId: string;
    ownerGender: string;
    car: CarEntity;
    description?: string;
    photoKeyUrl?: string;
    serviceUpdateReason?: string;
    acceptedTyC?: boolean;
    status: ServiceStatus;
    shop: ShopEntity;
}

export default ServiceEntity;
